import { profilePayloadToForm } from '../Account/profileFormUtils';
import { stripPhoneDigits } from '../../utils/phone';

/**
 * @param {string} raw
 * @returns {string}
 */
function toTenDigitMobile(raw) {
  const digits = stripPhoneDigits(raw);
  if (digits.length >= 10) return digits.slice(-10);
  return digits;
}

/**
 * @param {{ name?: string, username?: string, email?: string, mobile?: string, phone_number?: string }} | null | undefined} user
 */
export function contactFromStoredUser(user) {
  if (!user || typeof user !== 'object') {
    return { fullName: '', phone: '', email: '' };
  }
  const fullName = String(user.name || user.username || '').trim();
  return {
    fullName,
    phone: toTenDigitMobile(user.mobile || user.phone_number || ''),
    email: String(user.email || '').trim(),
  };
}

/**
 * @param {unknown} profileData — getProfile response body
 */
export function contactFromProfilePayload(profileData) {
  const mapped = profilePayloadToForm(profileData);
  const first = String(mapped.form?.first_name || '').trim();
  const last = String(mapped.form?.last_name || '').trim();
  const fromNames = [first, last].filter(Boolean).join(' ');
  const fullName = fromNames || String(mapped.username || '').trim();
  return {
    fullName,
    phone: toTenDigitMobile(mapped.phone_number),
    email: String(mapped.email || '').trim(),
  };
}

/**
 * Prefer profile fields when present; fall back to stored auth user.
 * @param {{ stored: ReturnType<typeof contactFromStoredUser>, profile: ReturnType<typeof contactFromProfilePayload> }} sources
 */
export function mergeCheckoutContact(sources) {
  const { stored, profile } = sources;
  return {
    fullName: profile.fullName || stored.fullName,
    phone: profile.phone || stored.phone,
    email: profile.email || stored.email,
  };
}
